import { AskRequest, AskRequestStatus } from '@hone-automation/common';
import { usePatchQueueRequestMutation } from './queue';
import { useQueueContext } from 'presentation/components/Queue/QueueContext';
import { useEvent } from './useEvent';

export function useMarkAsSolved(txId: string, locationId: string, activeTab: AskRequestStatus) {
  const { dispatch } = useQueueContext();
  const { dispatch: emitEvent } = useEvent('onQueueRequestResolve');

  const { isPending, mutate } = usePatchQueueRequestMutation((trx: AskRequest | undefined) => {
    if (!trx) return;

    const updatedRequest = {
      ...trx,
      locationId: locationId,
      type: 'Customer Request',
      status: 'Closed',
    } as unknown as AskRequest;

    dispatch({
      type: 'UPDATE_REQUEST',
      payload: {
        request: updatedRequest,
        status: 'Closed',
      },
    });

    dispatch({ type: 'SET_SELECTED_ITEM', payload: updatedRequest });

    emitEvent({
      field: 'Closed',
      duration: 5000,
      message: `Request marked as resolved. You can find it in the "Closed" tab.`,
    });
  });

  const markAsSolved = async (formData: { comment: string }) => {
    mutate({
      txId: txId,
      comment: formData.comment,
      status: 'Closed',
      locationId,
    });
  };

  return {
    isPending,
    markAsSolved,
  };
}
